import Loader from '@/components/utils/Loader';
import posthog from 'posthog-js';
import Vue from 'vue';
import { VueReCaptcha } from 'vue-recaptcha-v3';
import FormsApp from './modules/forms/FormsApp';
import './styles/app.scss';

Vue.component('Loader', Loader);

Vue.use(VueReCaptcha, { siteKey: process.env.VUE_APP_RECAPTCHA_KEY });

if (process.env.NODE_ENV === 'production') {
  posthog.init('phc_a3joAYUp6aH23bBHM4E0Y8rMpcgqhsNVBU6QT7vvlt1',
    {
      api_host: 'https://eu.i.posthog.com',
      person_profiles: 'always',
      enable_recording_console_log: true,
    });
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: (h) => h(FormsApp),
});
